// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"920da1a7","335":"52c35e6e","379":"105c38b8","483":"66887ce0","488":"ef9ef258","681":"2e351501"}[chunkId] + ".chunk.js";
};